import { SafeDictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { useSelector } from "react-redux";

const useProductsForProductInfoListCollection = (ids: string[]) => {
    return useSelector((state: ApplicationState) => {
        const productsById: SafeDictionary<ProductModel[]> = {};

        ids.forEach(id => {
            productsById[id] = getProductsForProductInfoList(state, id);
        });

        return productsById;
    });
};

export default useProductsForProductInfoListCollection;
